var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b97d6d"
    },
    d: "M483.531,513H28.469C12.747,513,0,500.253,0,484.531V29.469C0,13.747,12.747,1,28.469,1h455.062 C499.253,1,512,13.747,512,29.469v455.062C512,500.253,499.253,513,483.531,513"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M52.966,431.565V82.434c0-15.722,12.747-28.469,28.469-28.469h349.131 c15.722,0,28.469,12.747,28.469,28.469v349.131c0,15.722-12.747,28.469-28.469,28.469H81.435 C65.713,460.034,52.966,447.287,52.966,431.565"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b97d6d"
    },
    d: "M220.691,407.069c-4.882,0-8.828-3.946-8.828-8.828V124.586c0-4.882,3.946-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v273.655C229.518,403.123,225.572,407.069,220.691,407.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b97d6d"
    },
    d: "M256.001,309.966h-35.31c-4.882,0-8.828-3.946-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c43.811,0,79.448-35.637,79.448-79.448s-35.637-79.448-79.448-79.448h-35.31c-4.882,0-8.828-3.946-8.828-8.828 s3.946-8.828,8.828-8.828h35.31c53.539,0,97.103,43.564,97.103,97.103S309.54,309.966,256.001,309.966"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.f3343a3f4d09abe96528b9ea50d9a37c.svg";
export { ForwardRef as ReactComponent };